<div>
  <header
    *ngIf="showLabel"
    class="font-bold text-l flex align-items-center gap-2 h-3rem">
    <app-data-layer-type-icon [dataLayerType]="dataLayerType" />
    <span>{{ dataLayerType.name }}</span>
    @if (showControls && activeUserStore.canAccessEntityAdder()) {
      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
      <p-button
        [rounded]="true"
        severity="secondary"
        class="ml-auto"
        [text]="true"
        (click)="menu.toggle($event)"
        icon="fas fa-ellipsis-vertical" />
    }
  </header>
  <div
    *ngIf="dataLayerStore.filterByParent(dataLayerType._id) as dataLayers"
    class="flex flex-wrap gap-3">
    @if (dataLayers.length === 0) {
      <app-alert
        styleClass="m-0 p-2"
        severity="secondary"
        text="Erforderlich: Neues Jahr hinzufügen"></app-alert>
    }
    <app-year-list [dataLayers]="dataLayers" [selectionMode]="selectionMode" />
  </div>
</div>
